export default {
    NO_RESULTS: 'no_results'
};
